/* Cart drawer: clicking the cart icon inside the drawer header closes it.
   (That icon is rendered clickable:false, so it has no data-action of its own.)

   NB: we deliberately do NOT intercept the header [data-action='show-cart-drawer']
   trigger. Add-to-bag opens the drawer by programmatically clicking that trigger
   (and 'cart:item-added' already auto-opens it), so toggling there would close the
   drawer immediately after adding. The header icon is unreachable while the modal
   drawer is open anyway; backdrop-dismiss handles outside clicks. */
(function () {
  var CLOSE_EVENT = 'fluco:modal:cartDrawer:close';

  document.addEventListener('click', function (event) {
    if (event.target.closest('.cart-drawer__header-content-right .cart-button')) {
      event.preventDefault();
      window.dispatchEvent(new Event(CLOSE_EVENT));
    }
  });
})();
